import React from 'react';
import classnames from 'classnames';
import styles from './field-validation.css';

interface FieldValidationProps {
  /** Boolean to indicate whether validation should show */
  isVisible: boolean;
  /** Message to be shown on the validation */
  children: string | JSX.Element;
  /** Describes whether the banner should be shown on top or bottom of the field */
  display?: 'top' | 'bottom';
  /** Pixel value of top postion the field validation should be placed at */
  top?: number;
  /** Pixel value of bottom position the field validation should be placed at */
  bottom?: number;
  /** Adds a custom class to the validation banner */
  className?: string;
  /** Provides a data-testid */
  'data-testid'?: string;
}

/**
 * Component to display Validation error messages for the other elemnts
 *
 * @param {FieldValidationProps} props
 *
 * @returns JSX.ELEMENT
 */
export const FieldValidation = ({
  top,
  bottom,
  isVisible,
  className,
  children,
  'data-testid': dataTestId,
  display = 'bottom'
}: FieldValidationProps) => {
  const validationClasses = classnames(
    {
      [styles.fieldValidation]: true,
      [styles.hidden]: !isVisible,
      [styles.top]: display === 'top',
      [styles.bottom]: display === 'bottom'
    },
    className
  );

  let position = {};
  if (top) {
    position = { ...position, top: `${top}px` };
  }
  if (bottom) {
    position = { ...position, bottom: `${bottom}px` };
  }

  return (
    <div className={validationClasses} style={position} data-testid={dataTestId}>
      {children}
    </div>
  );
};

export default FieldValidation;
